import { QuestionType } from './question-type';
import { QuestionAnswer } from './question-answer';
import { QuestionFactorType } from './question-factor-type';
import { BaseEntity } from './base-entity';

export class Question extends BaseEntity {
  threatId?: string; // helpful for mocking data
  weight: number;
  type: QuestionType;
  evenWeight: boolean;
  increasingAnswer: QuestionAnswer;
  position: number;
  requireCommentForNA: boolean;
  factorType: QuestionFactorType;
  isDefaultQuestion: boolean;
  conditionalDepends?: Question;
  conditionalOn?: QuestionAnswer;
  uid?: string;
  conditionalDependsUid?: string;

  constructor(uid?: string, evenWeight?: boolean) {
    super();
    this.uid = uid;
    this.evenWeight = evenWeight || false;
  }
}
